import type { GuideLayer } from "../../shared/guide";
import { ExpandableMedia } from "./ExpandableMedia";
import { MermaidDiagram } from "./MermaidDiagram";

function VisualChange({ layer }: { layer: GuideLayer }) {
  if (!layer.visualChange) return null;
  const snapshots = [
    { label: "Before", ...layer.visualChange.before },
    { label: "After", ...layer.visualChange.after },
  ];
  return (
    <section className="presentation-card visual-change" aria-label="Visual change">
      <div className="section-title">Visual result</div>
      <div className="visual-grid">
        {snapshots.map((snapshot) => (
          <figure key={snapshot.label}>
            <div className="visual-label">{snapshot.label}</div>
            <ExpandableMedia description={snapshot.caption} label={`${snapshot.label}: ${snapshot.alt}`}>
              <img alt={snapshot.alt} src={snapshot.src} />
            </ExpandableMedia>
            <figcaption>{snapshot.caption}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}

function InfrastructurePlan({ layer }: { layer: GuideLayer }) {
  if (!layer.infrastructurePlan) return null;
  const plan = layer.infrastructurePlan;
  return (
    <section className="presentation-card infrastructure-plan" aria-label="Infrastructure plan">
      <div className="section-title">Infrastructure changes</div>
      <div className="plan-counts">
        <div><strong>{plan.create}</strong><span>Create</span></div>
        <div><strong>{plan.change}</strong><span>Change</span></div>
        <div className={plan.destroy > 0 ? "plan-destroy" : ""}><strong>{plan.destroy}</strong><span>Destroy</span></div>
      </div>
      <dl className="plan-safety">
        <div><dt>Blast radius</dt><dd>{plan.blastRadius}</dd></div>
        <div><dt>Rollback</dt><dd>{plan.rollback}</dd></div>
      </dl>
    </section>
  );
}

export function LayerPresentation({ layer }: { layer: GuideLayer }) {
  if (layer.presentation === "visual-change") return <VisualChange layer={layer} />;
  if (layer.presentation === "infrastructure-plan") return <InfrastructurePlan layer={layer} />;
  if (layer.diagram) {
    return (
      <section className="presentation-card presentation-diagram" aria-label="Change flow">
        <div className="section-title">
          {layer.presentation === "query-lineage" ? "Inputs, transformation, and outputs" : "Change flow"}
        </div>
        <MermaidDiagram source={layer.diagram} />
      </section>
    );
  }
  return null;
}
